import { ActionContext } from 'vuex'
import { RootState } from '../types'
import rest from '@/rest'
import { AppSettings } from '@/types/settings'

interface SettingsState {
  appSettings: AppSettings | null
  loading: boolean
}

const state: SettingsState = {
  appSettings: null,
  loading: false
}

type SettingsActionContext = ActionContext<SettingsState, RootState>

const mutations = {
  SET_LOADING (state: SettingsState, loading: boolean) {
    state.loading = loading
  },
  SET_APP_SETTINGS (state: SettingsState, data: AppSettings) {
    state.appSettings = data
  }
}

const actions = {
  async LOAD_APP_SETTINGS (ctx: SettingsActionContext): Promise<void> {
    ctx.commit('SET_LOADING', true)
    try {
      const data = await rest.settings.getAppSettings()
      ctx.commit('SET_APP_SETTINGS', data)
    } finally {
      ctx.commit('SET_LOADING', false)
    }
  },

  async DISABLE_APP (ctx: SettingsActionContext, appId: string): Promise<void> {
    ctx.commit('SET_LOADING', true)
    try {
      await rest.settings.disableApp(appId)
      await ctx.dispatch('LOAD_APP_SETTINGS')
    } finally {
      ctx.commit('SET_LOADING', false)
    }
  },

  async ENABLE_APP (ctx: SettingsActionContext, appId: string): Promise<void> {
    ctx.commit('SET_LOADING', true)
    try {
      await rest.settings.enableApp(appId)
      await ctx.dispatch('LOAD_APP_SETTINGS')
    } finally {
      ctx.commit('SET_LOADING', false)
    }
  }
}

const getters = {
  loading: (state: SettingsState) => state.loading,
  appSettings: (state: SettingsState) => state.appSettings,
  isAppDisabled: (state: SettingsState) => (appId: string): boolean => {
    return state.appSettings?.disabled_apps.includes(appId) ?? false
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
